import { useEffect, useState } from "react";

// Usa el plazo del inicio de sesión, incluso al recargar o cambiar de módulo.
export function useHelpPrompt(expiresAt) {
  const valid = Number.isFinite(expiresAt) && expiresAt > 0;
  const [visible, setVisible] = useState(() => valid && Date.now() < expiresAt);
  useEffect(() => {
    let timer;
    const check = () => {
      clearTimeout(timer);
      const remaining = valid ? expiresAt - Date.now() : 0;
      setVisible(remaining > 0);
      if (remaining > 0) timer = setTimeout(check, remaining);
    };
    check();
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", check);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", check);
    };
  }, [expiresAt, valid]);
  return visible && valid && Date.now() < expiresAt;
}
